<template>
  <div>
    <!-- :get-form-data="fromData" -->
    <list
      row-key="UserId"
      ref="list"
      unit="模具工艺"
      :page="page"
      :show-checkbox="multiple"
      :show-query="true"
      :query-params="params"
      :get-data-func="api.list"
      @check-change="checkChange"
      :reset-data-func="resetData"
      v-if="trendShow"
      urlHash="production/craftsmanship/solutions/mold"
      :temp-params="tempParams"
    >
      <template slot="toolbar-right">
        <slot name="toolbar-right"></slot>
      </template>
      <template slot="table">
        <slot name="column"></slot>
      </template>
    </list>
  </div>
</template>
<script>
import listMixin from "@/mixins/trend/list";
import list from "@/components/common/trendsTable/list";

export default {
  mixins: [listMixin],
  components: { list },
  props: {
    multiple: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      api: require('@/api/production/teProgramme').default,
      trendShow: true,
      params: {
        MouldNo: "",
        ProgrammeName: "",
      },
      tempParams: {
        ProgrammeType: 0
      },
      mouldOption: [],
      ids: [],
    };
  },
  mounted(){
     
  },
  methods: {
    checkChange(ids) {
      this.ids = ids.map(v => {
        return v.ProgrammeId
      });
      
    },
    del() {
      if(this.ids.length === 0){
        this.$message({type: 'warning', message: '请选择删除的数据'});
        return;
      }
      this.$confirm("确定删除这些记录?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.api.delete({ Ids: this.ids }).then((res) => {
          if (res.Code === 0) {
            this.$message({ type: "success", message: res.Mes });
            this.reload();
          } else {
            this.$message({ type: "warning", message: res.Mes });
          }
        });
      });
    },
    resetData(data){
      
      data.forEach(item => {
        let str = '';
        let length = item.Moulds.length
        item.Moulds.forEach((v, i) => {
          if(i === length - 1){
            str += v.MouldName
          }else{
            str += v.MouldName + ','
          }
        })
        item.MouldName = str;
      })
      return data
    }
  }
};
</script>
